export default "__VITE_ASSET__WrVCjZiB__"